import { ChangeDetectorRef, Component, OnDestroy, OnInit } from "@angular/core";
import { AlertService, ModalService, ProxyService } from "@app/core/services";
import { Subscription } from "rxjs";
import { ApiRoutes } from "@shared/models/configs/api.endpoints";

@Component({
  selector: "app-guest-signup-terms-conditions",
  templateUrl: "./guest-signup-terms-conditions.component.html",
  styleUrls: ["./guest-signup-terms-conditions.component.less"],
})
export class GuestSignupTermsConditionsComponent implements OnInit,OnDestroy {
  public successResponse: string;
  public loading: boolean;
  guestResponse: string;
  constructor(
    private proxy: ProxyService,
    private modalService: ModalService,
    private cdr: ChangeDetectorRef,
    private alertService: AlertService,
   
  ) {
    this.getTermsAndConditionsText();
    this.loading = false;

  }

  ngOnInit(): void {
    this.modalService.modalOptions.subscribe((succ) => {
      this.guestResponse=succ;
    });
  }

  private getTermsAndConditionsText() {
    const reqParams = "terms-conditions";
    this.proxy.httpGet(ApiRoutes.AUTH_TERMSANDCONDITIONS + reqParams).subscribe(
      (success) => {
        this.successResponse = success.body.valueOf().toString();
        this.cdr.detectChanges();
      },
      (err) => {
        // technically status 200 is a "success" and not an error to the server. Although the
        // it is technically an http error code so shows here.
        if (err.status === 200) {
          this.successResponse = err.error.text;
        }
        this.alertService.error(err.error.message);
        this.cdr.detectChanges();
      }
    );
  }

  ngOnDestroy(): void {
    setTimeout(() => {
      this.modalService.setModalSelector(
        "guest-sign-up",
       this.guestResponse
      );
      this.modalService.showModal(false);
    }, 400);
  
  }

}
